<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-claims-claim-type-dialog-create
          v-if="$hasPermissionTo(['create claim types'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Claim Type's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in claim type here"
          append-icon="search"
          label="Search Claim Type"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="filteredHeaders"
      :items="filteredClaimTypes"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.name="{ item }">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                color="hrissecondary"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <v-row 
              no-gutters
              class="text-left"
            >
              <v-col cols="6">
                Expense Type
              </v-col>
              <v-col cols="1">
                :
              </v-col>
              <v-col cols="5">
                {{ item.expense_type ? item.expense_type.toUpperCase() : '' }}
              </v-col>
              <v-col cols="6">
                Claimed By
              </v-col>
              <v-col cols="1">
                :
              </v-col>
              <v-col cols="5">
                {{ item.claimed_by ? item.claimed_by.toUpperCase() :'' }}
              </v-col>
            </v-row>
          </v-tooltip>
          <span>
            {{ item.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.requires_confirmation="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_confirmation"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.requires_receipt="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_receipt"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.requires_document="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_document"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.is_description_mandatory="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.is_description_mandatory"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.allow_advance_purchase="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.allow_advance_purchase"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.has_limit="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.has_limit"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.allow_exceed_limit="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.allow_exceed_limit"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.allow_higher_level_approval="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.allow_higher_level_approval"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.requires_declaration="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_declaration"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span
          v-if="statusFilter"
          style="display:inline-block;width:80px"
        >
          <setup-claims-claim-type-dialog-edit
            v-if="$hasPermissionTo(['update claim types'])"
            :claim-type="item"
            @updated="loadData"
          />
          <setup-claims-claim-type-dialog-delete
            v-if="$hasPermissionTo(['delete claim types'])"
            :claim-type="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-claims-claim-type-dialog-restore
            v-if="$hasPermissionTo(['restore claim types'])"
            :claim-type="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimTypeDialogCreate: () => import('@/components/hris/setup/claims/claim-type/DialogCreate'),
      SetupClaimsClaimTypeDialogEdit: () => import('@/components/hris/setup/claims/claim-type/DialogEdit'),
      SetupClaimsClaimTypeDialogDelete: () => import('@/components/hris/setup/claims/claim-type/DialogDelete'),
      SetupClaimsClaimTypeDialogRestore: () => import('@/components/hris/setup/claims/claim-type/DialogRestore'),
    },
    data () {
      return {
        claimTypes: [],
        trashedClaimTypes: [],
        headers: [
          {
            text: 'Claim Types',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Requires Document?',
            align: 'center',
            value: 'requires_document',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Requires Confirmation?',
            align: 'center',
            value: 'requires_confirmation',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Requires Receipt?',
            align: 'center',
            value: 'requires_receipt',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Allow Advance Purchase?',
            align: 'center',
            value: 'allow_advance_purchase',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Is Description Mandatory?',
            align: 'center',
            value: 'is_description_mandatory',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Has Limit?',
            align: 'center',
            value: 'has_limit',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Allow Exceed Limit?',
            align: 'center',
            value: 'allow_exceed_limit',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Allow Higher Approval?',
            align: 'center',
            value: 'allow_higher_level_approval',
            sortable: false,
            width: '15px',
          },
          {
            text: 'Requires Declaration?',
            align: 'center',
            value: 'requires_declaration',
            sortable: false,
            width: '15px',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        combinedClaimTypes: [],
      }
    },
    computed: {
      filteredHeaders () {
        return this.canUpdateClaimTypes() ? [...this.headers, {
          text: '',
          value: 'action',
          sortable: false,
          width: '20px',
        },
        ] : this.headers
      },
      filteredClaimTypes () {
        return this.statusFilter ? this.claimTypes : this.trashedClaimTypes
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      canUpdateClaimTypes () {
        return this.$hasPermissionTo(['update claim types']) || this.$hasPermissionTo(['delete claim types']) || this.$hasPermissionTo(['restore claim types'])
      },
      loadData () {
        Promise.all([
          this.$api.claimTypes().list(),
          this.$api.claimTypes().listTrashed(),
        ]).then(([claimTypes, trashedClaimTypes]) => {
          this.claimTypes = claimTypes.data
          this.trashedClaimTypes = trashedClaimTypes.data

          this.combinedClaimTypes = claimTypes.data.concat(trashedClaimTypes.data)

          this.$emit('updated')
          this.tableLoading = false
        })
      },
    },
  }
</script>
